/**
 * Template: Customers
 * -----------------------------------------------------------------------------
 * Used to import styles for all customer templates.
 *
 */
import '@/templates/customers.scss'

import CustomersHeader from '~/components/customers-header'

document.addEventListener('DOMContentLoaded', () => {
  CustomersHeader().init()
})
